export default __webpack_public_path__ + "static/media/maisons_laffitte3.cd138028.jpg";